import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'app-session-expired-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './session-expired-dialog.component.html',
  styleUrls: ['./session-expired-dialog.component.scss']
})
export class SessionExpiredDialogComponent {
  constructor(private dialogService: DialogService) {}

  /**
   * Handles OK button click
   */
  onOkClick(): void {
    // Simply call dialogService.close() - much simpler!
    this.dialogService.close(true);
  }
}

